
import { Link }
  from 'react-router-dom';

import RouteServers
  from 'app/components/navigation/RouteServers';

import logo from "../../../img/1-IX_logo_long.jpg"

const Sidebar = () => {
  return (
    <aside className="page-sidebar">
      <div className="sidebar-header">
        <div className="logo">
          <Link to='/'>
            <img height="75" src={logo} alt="1-IX logo" />
          </Link>
        </div>
      </div>
      <RouteServers />
    </aside>
  );
}

export default Sidebar;
